export const HIERARCHY_FIELD = 'HasChildren'
export const CHECKED_ADDITIONAL_FIELDS = {
  keyField: 'Id',
  hierarchyField: 'Parent',
  hierarchyRoot: null,
}
